import { userApi } from "@/shared/api"

export const useUser = () => {
  const verifyUser = async () => {
    return await userApi.verify()
  }

  return { verifyUser }
}
